import { ImageModel } from "@/models/ImageModel";
import { getNow } from "@/helpers/date_time";

export function saveImageToLocalDB(id, base64image) {
    const m = new ImageModel();
    m.setData({
        id,
        value: base64image,
        create_time: +getNow(),
    })
    return m.flush();
}